import { render, staticRenderFns } from "./OnlinePackages.vue?vue&type=template&id=f45cf6d8&"
import script from "./OnlinePackages.vue?vue&type=script&lang=js&"
export * from "./OnlinePackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlinePackages.vue"
export default component.exports